export enum FeeTypeEnum {
  MONEY_EXCHANGE_FEE = 'MONEY_EXCHANGE_FEE',
  CASH_OUT_FEE = 'CASH_OUT_FEE',
}
